exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.btn.over-99[data-v-1f81d04e] {\n  font-size: 11px;\n}\n", "", {"version":3,"sources":["/home/runner/work/treesoft-app/treesoft-app/src/components/apps/pos/sale/mobile/common/src/components/apps/pos/sale/mobile/common/TotalPriceButton.vue"],"names":[],"mappings":";AAmBA;EACA,gBAAA;CACA","file":"TotalPriceButton.vue","sourcesContent":["<template>\n  <button\n    :class=\"[btnPaymentDisabled]\"\n    class=\"btn btn-web\"\n    @click=\"onClickPayment()\"\n  >\n    {{ currencyFormatter(totalNumber, { code: currency }) }}\n  </button>\n</template>\n\n<script>\nimport totalPriceMixin from '@/mixins/pos/totalPrice'\n\nexport default {\n  mixins: [totalPriceMixin],\n}\n</script>\n\n<style scoped>\n.btn.over-99 {\n  font-size: 11px;\n}\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f81d04e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/apps/pos/sale/mobile/common/TotalPriceButton.vue
// module id = cwLe
// module chunks = 1